module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-layout direction-column"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('router-view')], 1), _vm._v(" "), _c('GridFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-453b9784"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/layout/layout.vue
// module id = 319
// module chunks = 40